<template>
  <div v-if="rankingList.articleThumbnailList > 0" class="post access mt48">
    <h2 class="title c5a ab">アクセスランキング</h2>
    <div class="post_list mt48">
      <post v-for="(val, index) in rankingList.articleThumbnailList"
        :title="val.title"
        :hashtag="val.tagList"
        :date="val.publicationDate"
        :is_new="false"
        :is_ranking="0"
        :id="val.articleId"
        :key="index"
      />
    </div>
  </div>
</template>

<script>
import Post from '@/components/fanClub/column/Post';
import TagList from '@/components/api/fanClub/article';

export default {
  components: {
    Post,
  },
  data() {
    return {
      rankingList: {
        articleThumbnailList: [],
      },
    }
  },
  methods: {
    addRankingList(val) {
      this.rankingList.articleThumbnailList.push(...val);
    },
    async apiGetRankingList() {
      await TagList.getRankingList().then((val) => {
        console.log('ランキング');
        console.log(val);
        this.rankingList.articleThumbnailList.splice(0, val.length);
        // newColumnList
        this.addRankingList(val);
      });
    },
  },
  created() {
    this.apiGetRankingList();
  },
}
</script>

<style lang="css" scoped>
.title {
  text-align: center;
}
.post_list {
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/fanClub/column/AccessRanking.vue